import React from 'react';
import PropTypes from 'prop-types';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDTitleText } from '@facet-wealth/design';
import {
  GoalSummaryItemLineItem,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/components/GoalSummaryItemLineItem';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const GoalSummaryItemLineItemCollectionOverride = fr.metaOverride({ base: BaseOverride })
  .override({ readonly: true }, {
    _component: () => GoalSummaryItemLineItem,
  }, overrideReadOnly)
  .nameOverride('title', {
    hidden: false,
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly);

const GoalSummaryItemLineItemLayout = () => {
  const { resource } = useMetaLayoutContext();
  const fields = resource.meta().template().list();
  return fields.map((field) => <MetaControlField key={field.attr('name')} attr={field.attr('name')} />);
};

const GoalSummaryItemLineItemCollection = ({
  collection,
}) => {
  return (
    <MetaCollectionRenderer collection={collection} layout={GoalSummaryItemLineItemLayout} metaOverrideSet={GoalSummaryItemLineItemCollectionOverride} />
  );
};

GoalSummaryItemLineItemCollection.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export { GoalSummaryItemLineItemCollection };
